import React from "react";

import { Option } from "./SelectWithIcons";

const colorsByType = testKey => {
  return (
    {
      "presential-interview": ["#d86062", "#f6dadb"],
      "remote-interview": ["#87b351", "#e9f1df"],
      "tel-interview": ["#02b4f4", "#ccedf6"],
      "group-interview": ["#f18f1e", "#fdeedd"],
      "chat-message": ["#505053", "#eaeaeb"],
      test: ["#77a940", "#e6f1da"],
      document_upload: ["#7b61ff", "#efebff"],
      chatbot: ["#2e75b8", "#ebf3fa"]
    }[testKey] || ["#505053", "#eaeaeb"]
  );
};

const iconByType = testKey => {
  return (
    {
      "presential-interview": "environment",
      "remote-interview": "customer-service",
      "tel-interview": "phone",
      "group-interview": "team",
      "chat-message": "message",
      test: "solution",
      document_upload: "file-text",
      chatbot: "robot"
    }[testKey] || "build"
  );
};

const StepTypeOption = ({ t, typeKey }) => {
  const [iconColor, iconBackgroundColor] = colorsByType(typeKey);

  return (
    <Option
      title={t(`opportunity:process.stepTypes.${typeKey}.title`)}
      description={t(`opportunity:process.stepTypes.${typeKey}.description`)}
      icon={iconByType(typeKey)}
      iconColor={iconColor}
      iconBackgroundColor={iconBackgroundColor}
    />
  );
};

export default StepTypeOption;
